import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=821fafdc"
import script from "./Budget.vue?vue&type=script&lang=ts"
export * from "./Budget.vue?vue&type=script&lang=ts"
import style0 from "./Budget.vue?vue&type=style&index=0&id=821fafdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports